// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"74":"About","177":"home","372":"Business","596":"404","952":"Address","997":"Message"}[chunkId] || chunkId) + "." + {"74":"41ec6b05","177":"3d84cefd","372":"3842cb14","596":"bd1ed9c9","604":"2ca33cc8","952":"0a581366","997":"8f188226"}[chunkId] + ".js";
};